import React, { useState, useContext } from 'react';
import { FaTimes, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import { currencySymbolLeft, getSystemSettings } from '../../../../functions/Functions';
import { BASE_URL } from '../../../../BaseUrl';
import { SettingsContext } from '../../../../contexts/Settings';
import Moment from 'react-moment';
import './ViewOrderModal.css';

const ViewOrderModal = ({ isOpen, onClose, order, orderDetail, showImages = true }) => {
  const [expandedItems, setExpandedItems] = useState({});
  const { generalSettings } = useContext(SettingsContext) || {};

  if (!order) return null;

  const totalPriceWithTaxLocal = (total, subtotal, vat, discount, branch, key) => {
    let totalPrice = parseFloat(total || 0);
    const taxObj = branch?.payment_tax || branch;
    const foundKey = taxObj && typeof taxObj === 'object' && Object.keys(taxObj).find(k => k.toLowerCase() === key);
    if (foundKey && taxObj[foundKey] && taxObj[foundKey] > 0) {
      const taxTypeDiscount = generalSettings && getSystemSettings(generalSettings, "tax_type_discount") === "tax_discount_after";
      const taxTypeFixed = generalSettings && parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) !== 1;
      const calAmount = (taxTypeDiscount && taxTypeFixed) ? (parseFloat(subtotal || 0) - parseFloat(discount || 0)) : parseFloat(subtotal || 0);
      const inclusive_vat = calAmount * (parseFloat(taxObj[foundKey]) / 100);
      const previous_amount = parseFloat(total || 0) - parseFloat(vat || 0);
      totalPrice = previous_amount + inclusive_vat;
      console.log("abcd6",totalPrice,previous_amount,inclusive_vat, calAmount,subtotal,vat)
    }
    return [Math.round(totalPrice), foundKey ? taxObj[foundKey] : 0];
  };

  const showCashCard = 1;

  const toggleItem = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const branchData = orderDetail?.branch || order?.branch;
  const [cashTotal, cashTaxRate] = totalPriceWithTaxLocal(order.total_payable, order.order_bill, order.vat, order.discount_amount, branchData, "cash");
  const [cardTotal, cardTaxRate] = totalPriceWithTaxLocal(order.total_payable, order.order_bill, order.vat, order.discount_amount, branchData, "card");

  return (
    <Modal show={isOpen} onHide={onClose} centered scrollable dialogClassName="view-order-dialog" contentClassName="border-0 shadow view-order-content">
      <div className="view-order-header d-flex align-items-center justify-content-between w-100">
        <div className="view-order-close-btn-spacer"></div>
        <div className="text-dark mb-0 text-center flex-grow-1 view-order-title">Your Order #{order.order_no}</div>
        <button 
          type="button" 
          className="view-order-close-btn" 
          onClick={onClose}
          aria-label="Close"
        >
          <FaTimes className="view-order-close-icon" />
        </button>
      </div>
            
      <div className="modal-body p-0 bg-white">
        <div className="order-items-list px-3">
          {order.items?.map((item, index) => {
            const hasAddons = item.property && item.property.length > 0;
            const isExpanded = expandedItems[index];

            return (
              <div key={index} className="border-bottom view-order-item">
                <div className="d-flex align-items-start">
                  {/* Keep order details consistent with the branch image preference. */}
                  {showImages && <div className="view-order-item-image-wrapper mr-3">
                    <img 
                      src={item.item_image ? BASE_URL + item.item_image : "/assets/img/default-item.jpeg"} 
                      alt={item.item_name}
                      className="view-order-item-image"
                      onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/default-item.jpeg" }}
                    />
                  </div>}
                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <div className="mb-2 text-dark view-order-item-name">{item.item_name}</div>
                        <div className="d-flex flex-wrap gap-2 align-items-center">
                          {item.variation && (
                            <span className="view-order-variation">
                              {item.variation}
                            </span>
                          )}
                          <span className="view-order-qty-badge">
                            Qty: {item.qty}
                          </span>
                        </div>
                      </div>
                      <div className="text-end ml-3 d-flex flex-column align-items-end justify-content-start">
                        <span className="view-order-price mb-1">
                          {currencySymbolLeft()} {item.price}
                        </span>
                        {item.created_at && (
                          <span className="view-order-time-badge text-muted" style={{ fontSize: '0.85rem' }}>
                            <Moment format="LT">{item.created_at}</Moment>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {hasAddons && (
                  <div className="mt-3 pt-2 view-order-addons-container">
                    <button 
                      className="btn btn-sm btn-link text-decoration-none p-0 d-flex align-items-center w-100 justify-content-between view-order-addons-toggle"
                      onClick={() => toggleItem(index)}
                    >
                      <span className="view-order-view-addons">View Add-ons</span>
                      {isExpanded ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                    </button>
                    
                    {isExpanded && (
                      <div className="mt-2 view-order-addons-list">
                        {item.property.map((prop, pIdx) => (
                          <div key={pIdx} className="d-flex justify-content-between align-items-start mb-2 pb-2 view-order-addon-row">
                            <div className="text-muted text-break pe-2 view-order-addon-name">
                              • {prop.name || prop.property || 'Add-on'}
                              <span className="ml-2 text-dark view-order-addon-qty">x{prop.qty || prop.quantity || 1}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      
      <div className="view-order-footer d-flex justify-content-between align-items-center">
        <span className="view-order-total-label">Total</span>
        <span className="text-dark view-order-total-price">{currencySymbolLeft()} {order.total_payable}</span>
      </div>

      {showCashCard && (
        <>
          <div className="view-order-footer d-flex justify-content-between align-items-center border-top">
            <span className="view-order-total-label">Cash Net Bill
              {cashTaxRate > 0 && ` (${cashTaxRate}%)`}
            </span>
            <span className="text-dark view-order-total-price">{currencySymbolLeft()} {cashTotal}</span>
          </div>
          <div className="view-order-footer d-flex justify-content-between align-items-center border-top">
            <span className="view-order-total-label">Card Net Bill
              {cardTaxRate > 0 && ` (${cardTaxRate}%)`}
            </span>
            <span className="text-dark view-order-total-price">{currencySymbolLeft()} {cardTotal}</span>
          </div>
        </>
      )}
    </Modal>
  );
};

export default React.memo(ViewOrderModal);
